import {IListColumnProps} from '../../../../src/@interfaces/components/List/IListColumnProps';
import React from 'react';
import {AttentionMessageProps, renderOrderAttentionRepresentation} from './messages';
import {ListConfigNamedColumn} from '../../../../src/@types/components/List';

function Fallback(props: Omit<AttentionMessageProps, 'setMessages' | 'catchHttpException'>) {
    return <div className="alert alert-danger">
        Message with type [{props.model.type}] not found
    </div>;
}

export function MessageColumn(props: IListColumnProps<ListConfigNamedColumn, AttentionMessageProps['model']>) {
    const model = props.model;
    const message = model == null ? null : renderOrderAttentionRepresentation(model);

    return message ?? <Fallback model={model}/>;
}
